import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used on Leesona 861 Tackified and Gilbos Doubler machines

export default function ClockSettingRow() {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };

   return (
      <Row className="mb-2">
         <ColPrompt title={"Clock Setting"} bold={true} description={"m"} />
         <ColValue size={4}>
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.clockSetting || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 1, 99999, "clockSetting")
                     : handleInputRangeChange(defaultOnChangeVal, 1, 99999, "clockSetting")
               }
            />
            {errorDivDefinitions.clockSetting && (
               <ErrorDiv>1-99,999 only</ErrorDiv>
            )}
         </ColValue>
      </Row>
   );
}